import {Component} from "preact";
import {translate} from "../../../../../../services/TranslateService";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import Toolbar from "../../../../../layout/toolbar";
import ToolbarButton from "../../../../../common/toolbar-button";
import Spinner from "../../../../../common/spinner";
import SendIcon from "mdi-preact/SendIcon";
import ArrowLeftIcon from "mdi-preact/ArrowLeftIcon";
import JWTClient from "../../../../../../services/JWTClient";
import ConfigService from "../../../../../../services/ConfigService";
import JsonApiDeserializer from "../../../../../../services/JsonApiDeserializer";
import BackdropCover from "../../../../../common/backdrop-cover";
import SectionComponent from "../../../../../layout/section-component";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import ErrorState from "../../../../../common/error-state";
import Text from "../../../../../common/text";
import ContactsInfiniteScrollList from "../contacts-infinite-scroll-list";

export default class CreateChat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            creating: false,
            error: false,
            selectedContacts: {},
        }
    }

    static defaultProps = {
        onNavigate : () => {},
        selectedContacts: {}
    };

    componentDidMount() {
        this.setState({selectedContacts: this.props.selectedContacts || {}});
    }

    render(props, state, context) {
        const creationSpinner = <BackdropCover><Spinner/></BackdropCover>;
        const minimumSelected = Object.keys(this.state.selectedContacts).length;

        return (
            <VerticalUiContainer>
                {this.state.creating ? creationSpinner : null}
                <Toolbar style={{borderBottom: '1px solid #eee', height: '4em'}}>
                    <SectionComponent style={{flexGrow: 0}}>
                        <ToolbarButton onClick={this.backToList} title={translate('action.back')}><ArrowLeftIcon/></ToolbarButton>
                    </SectionComponent>

                    <div style={{flexGrow: 2}}>
                        <ToolbarTitle><Text text={'chat.new.title'}/></ToolbarTitle>
                    </div>

                    <SectionComponent style={{flexShrink: 0}}>
                        <ToolbarButton onClick={this.newChat} disabled={!minimumSelected} title={translate('action.send')}><SendIcon/></ToolbarButton>
                    </SectionComponent>
                </Toolbar>

                {(state.error) ? (
                    <ErrorState>
                        <Text text={'error.loading'}/>
                        <ToolbarButton type={'primary fill'} style={{marginTop: '1em'}} onClick={this.newChat}>
                            <Text text={'action.retry'}/>
                        </ToolbarButton>
                    </ErrorState>
                ) : (
                    <ContactsInfiniteScrollList selectedContacts={state.selectedContacts} onSelect={this.onSelect}/>
                )}

            </VerticalUiContainer>
        );
    }

    onSelect = (contacts) => {
        this.setState({selectedContacts: contacts});
    };

    newChat = () => {
        const selectedContacts = Object.keys(this.state.selectedContacts).map(k => this.state.selectedContacts[k]);
        if (!selectedContacts.length) return;

        if (selectedContacts.length > 1) {
            this.props.onNavigate('createGroup', {selectedContacts: this.state.selectedContacts});
            return;
        }

        const subjectsData = selectedContacts.map(c => {return {
            name: c.username,
            email: c.email,
            reference: c.reference
        }});

        const profile = ConfigService.userProfile();
        subjectsData.push({
            name: profile.username,
            email: profile.email,
            reference: profile.reference
        });

        this.setState({creating: true});
        const url = ModuleInfoProvider.getModuleWebServiceUrl('chat');
        JWTClient.fetch(url + '/chats', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                type: 'singleChat',
                subjects: subjectsData
            })
        })
            .then(res => {
                const chat = JsonApiDeserializer.deserializeItem(res.data, res.included);
                this.props.onNavigate('read', {chat: chat});
                this.setState({creating: false, error: false});
            })
            .catch(err => {
                console.error(err);
                this.setState({creating: false, error: true});
            })
        ;
    };

    backToList = () => {
        return this.props.onNavigate('list');
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/create-chat/index.js